const previousPolicyTitleClass = 'whitespace-pre-line text-[18px] font-[550] mb-2';
const previousPolicyBodyClass = 'whitespace-pre-line w-full max-w-[728px] text-[13px] md:text-[15px] leading-7 text-[#374151]';

export const PREVIOUS_PRIVACY_POLICY = [
  <>
    <p className={previousPolicyTitleClass}>개인정보 처리방침 안내</p>
    <p className={previousPolicyBodyClass}>
      {`저희 주식회사 브이드림은 이용자들의 개인정보를 소중히 다루고 개인정보와 관련된 법규를 준수하고 있습니다. 주식회사 브이드림(이하 '회사')는 “정보통신망 이용촉진 및 정보보호에 등에 관한 법률” 및 "개인정보보호법"을 준수하고 있으며, 개인정보 처리방침을 마련하여 이용자 권익보호에 최선을 다하고 있습니다.

        회사의 개인정보처리방침은 정부의 법률 및 지침 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있고, 이에 따른 개인정보처리방침의 지속적인 개선을 위하여 필요한 절차를 정하고 있습니다. 그리고 개인정보처리방침을 개정하는 경우나 개인정보처리방침이 변경될 경우 홈페이지(www.vdream.co.kr)를 통해 고지하고 있습니다. 이용자들께서는 사이트 방문 시 수시로 확인하시기 바랍니다.`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>1. 개인정보 수집에 대한 동의</p>
    <p className={previousPolicyBodyClass}>
      {`회사는 고객님께서 개인정보처리방침 내용 중 개인정보 수집에 대하여 「동의합니다」 또는 「동의하지 않습니다」버튼을 클릭할 수 있는 절차를 마련하고 있으며, 「동의합니다」 버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.
        귀하는 동의를 거부할 수 있으며, 동의하지 않은 경우 당사의 서비스가 불가능할 수도 있음을 알려드립니다.`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>2. 개인정보의 수집 및 이용 목적</p>
    <p className={previousPolicyBodyClass}>
      {`"개인정보"라 함은 생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명, 주민등록번호 등의 사항에 의하여 당해 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함)를 말합니다.
        회사가 고객의 개인정보를 수집 이용하는 목적은 다음과 같습니다.

        가. 문의사항 또는 불만 처리 등 민원처리, 고지사항 전달, 분쟁 조정을 위한 기록 보존

        나. 이용자 맞춤형 서비스 제공

        다. 신규서비스 개발 • 마케팅 및 광고에 활용신규 서비스(콘텐츠) 개발 및 특화, 이벤트 등 광고성 정보 전달, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악, 이용자의 서비스 이용에 대한 통계`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>3. 개인정보의 수집 항목</p>
    <p className={previousPolicyBodyClass}>
      {`회사는 원활한 고객 상담, 기타 각종 서비스 등 서비스 제공을 위한 필수정보를 수집하고 있습니다.

        가. 회사는 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록 등)는 수집하지 않습니다. 그리고, 어떤 경우에라도 입력하신 정보를 이용자들에게 사전에 밝힌 목적 이외에 다른 목적으로는 사용하지 않으며 외부로 유출하지 않습니다.

        나. 회사는 다음과 같이 개인정보를 수집하여 이용합니다.
        개인정보 항목(입력 항목) : 기업명, 담당자명, 담당자직함, 기업 상시근로자 수, 기업 고용 중인 장애인 근로자 수, 이름, 휴대폰번호, 이메일, 주소, 장애 관련 정보, 작업능력, 자기소개서, 소속복지관, 비상연락처, 학력사항, 경력사항, 자격증, 포트폴리오

        다만, 서비스 이용과정에서 서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보, 결제기록 등이 생성되어 수집될 수 있습니다.`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>4. 개인정보의 수집 방법</p>
    <p className={previousPolicyBodyClass}>
      {`회사는 다음과 같은 방법으로 개인정보를 수집합니다.
        홈페이지(절감신청, 구직등록, 문의게시판) 및 고객센터를 통한 전화 및 온라인 상담`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>5. 개인정보의 보유 및 이용기간</p>
    <p className={previousPolicyBodyClass}>
      {`고객의 개인정보는 회사가 고객에게 서비스를 제공하는 기간 동안에 보유 및 이용됩니다.
       다만, 관계법령의 규정에 의하여 보존할 필요성이 있는 경우에는 관계법령에 따라 보존합니다.
        상법 및 ‘전자상거래등에서 소비자보호에 관한 법률’, 전자금융거래법, 여신전문금융업법 국세기본법, 법인세법, 부가가치세법 등 관련 법령의 규정에 의하여 다음과 같이 거래 관련 권리 의무 관계의 확인을 위하여 일정기간 보유하여야 할 필요가 있을 경우 개인정보는 일정기간 보유되며, 이 때 보유되는 개인정보의 열람 및 이용은 해당 사유로 국한되며, 사전에 보유목적, 기간 및 보유하는 개인정보 항목을 명시하여야 합니다.
        ㅤ- 보존 항목 : 이름, 휴대전화번호, 이메일
        ㅤ- 보존 근거 : 고객 문의사항의 원활한 응대 및 과거 문의에 대한 연계 답변 제공
        ㅤ- 보존 기간 : 1년

        고객님의 동의를 받아 보유하고 있는 개인정보에 대해 고객님께서 열람을 요구하는 경우에는 지체 없이 그 열람·확인할 수 있도록 조치합니다.

        전자상거래 등에서의 소비자 보호에 관한 법률 등 법령에서 일정기간 정보의 보관을 규정하는 경우는 아래와 같습니다. 회사는 이 기간 동안 법령의 규정에 따라 개인정보를 보관하며, 본 정보를 다른 목적으로는 절대 이용하지 않습니다.
        ㅤ- 전자상거래 등에서 소비자 보호에 관한 법률에 의거 소비자의 불만 및 분쟁처리에 관한 기록 : 3년 보관`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>6. 수집한 개인정보의 이용 및 제3자 제공</p>
    <p className={previousPolicyBodyClass}>
      {`회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
        ㅤ- 이용자들이 사전에 동의한 경우
        ㅤ- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우

        단, 보다 나은 서비스의 제공을 위하여 이용자의 개인정보를 협력업체 등과 공유할 필요가 있는 경우에는 제공받는 자, 주된 사업, 제공 목적 및 제공할 정보의 내용 등을 상세히 이용자에게 개별 고지하여 동의를 구하도록 하겠습니다.`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>7. 정보주체의 권리·의무 및 그 행사방법에 관한 사항</p>
    <p className={previousPolicyBodyClass}>
      {`가. 개인정보 열람 요구권
        ㅤ1) 정보주체는 회사가 처리하는 자신의 개인정보에 대한 열람을 요구할 수 있습니다.
        ㅤ2) 회사는 정보주체로부터 열람을 요구 받았을 때 10일 이내에 정보주체에게 해당 개인정보를 열람할 수 있도
        ㅤㅤ 록 하여야 합니다.
        ㅤㅤ 열람할 수 없는 정당한 사유가 있을 때에는 정보주체에게 그 사유를 알리고 열람을 연기할 수 있으며, 그 사유
        ㅤㅤ 가 소멸하면 지체 없이 열람하게 하여야 합니다.
        ㅤ3) 회사는 다음의 사유에 해당하는 경우에는 정보주체에게 그 사유를 알리고 열람을 제한하거나 거절할 수 있습
        ㅤㅤ 니다.
        ㅤㅤ① 법률에 따라 열람이 금지되거나 제한되는 경우
        ㅤㅤ② 다른 사람의 생명, 신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 
        ㅤㅤㅤ 있는 경우

        나. 개인정보 정정·삭제 요구권
        ㅤ1) 정보주체는 회사에게 자기 개인정보의 정정 또는 삭제를 요구할 수 있습니다. 다만, 법령에서 그 개인정보가
        ㅤㅤ 수집 대상으로 명시되어 있는 경우에는 삭제를 요구할 수 없습니다.
        ㅤ2) 회사는 정보주체가 자기 개인정보의 정정 또는 삭제를 요구할 경우 법령에 특별한 절차가 규정되어 있는 경
        ㅤㅤ 우를 제외하고는 지체 없이 정정, 삭제 등 필요한 조치를 취한 후 그 결과를 정보주체에게 알려야 합니다.
        ㅤ3) 정보주체가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 당해 개인 정보를 이용 또
        ㅤㅤ 는 제공하지 않습니다.
        ㅤ4) 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정하
        ㅤㅤ 도록 조치하겠습니다.
        ㅤ5) 회사가 개인정보를 삭제할 때에는 복구 또는 재생되지 않도록 조치하여야 합니다.
        ㅤ6) 회사는 필요한 경우 해당 정보주체에게 정정, 삭제 요구사항의 확인에 필요한 증거자료를 제출하게 할 수 있
        ㅤㅤ 습니다.

        다. 개인정보 처리정지 요구권
        ㅤ1) 정보주체는 회사가 처리하는 자신의 개인정보에 대한 열람을 요구할 수 있습니다.
        ㅤ2) 회사는 정보주체가 자기 개인정보 처리의 정지를 요구할 경우 지체 없이 개인정보 처리의 전부를 정지하거나
        ㅤㅤ 일부를 정지하여야 합니다.
        ㅤㅤ 다만, 다음의 경우에는 정보주체의 처리정지 요구를 거절할 수 있습니다.
        ㅤㅤ① 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우
        ㅤㅤ② 다른 사람의 생명, 신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가
        ㅤㅤㅤ 있는 경우
        ㅤㅤ③ 개인정보를 처리하지 아니하면 정보주체와의 근로 계약의 이행이 곤란한 경우로서 정보주체가 그 계약의
        ㅤㅤㅤ 해지의사를 명확하게 밝히지 아니한 경우
        ㅤ3) 회사는 정보주체의 요구에 따라 처리가 정지된 개인정보에 대하여 지체없이 해당 개인정보의 파기 등 필요한
        ㅤㅤ 조치를 하여야 합니다.

        라. 개인정보 열람/정정/삭제/처리정지 요청 방법
        ㅤ1) 정보주체는 열람/정정/삭제/처리정지 요청을 할 경우
        ㅤㅤ "개인정보 요구서" 양식을 작성하여 개인정보보호 담당자에게 메일로 전송해 주시면 즉시 처리해 드리도록
        ㅤㅤ 하겠습니다.`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>8. 개인정보의 수집, 이용, 제공에 대한 동의철회</p>
    <p className={previousPolicyBodyClass}>
      {`가. 개인정보의 수집, 이용, 제공에 대해 귀하께서 동의하신 내용을 귀하는 언제든지 철회하실 수 있습니다. 동의철회는 개인정보요구서를 통해 개인정보의 수집, 이용, 제공에 대하여 선택적으로 철회할 수 있으며, 개인정보보호책임자에게 서면, 전화, E-mail등으로 연락하시면 즉시 동의철회를 위해 필요한 조치를 취합니다. 동의 철회를 하고 개인정보를 파기하는 등의 조치를 취한 경우에는 그 사실을 귀하께 지체 없이 통지하도록 하겠습니다.
        (단, 서비스 제공에 필요한 필수정보의 수집과 이용에 관한 동의철회는 예외로 합니다.)

        나. 회사는 개인정보의 수집에 대한 동의철회를 개인정보를 수집하는 방법보다 쉽게 할 수 있도록 필요한 조치를 취합니다.`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>9. 개인정보 파기 절차 및 방법</p>
    <p className={previousPolicyBodyClass}>
      {`회사는 수집한 개인정보의 이용목적이 달성된 후에는 보관기간 및 이용기간에 따라 해당 정보를 지체 없이 파기합니다. 파기절차, 방법, 시점은 다음과 같습니다.

        가. 파기절차 및 시점
        고객이 서비스 이용 등을 위해 기재한 개인정보는 서비스 해지 등 이용목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유(위 개인정보의 보유 및 이용기간 참조)에 따른 보유기간이 경과한 후에 삭제되거나 파기합니다. 일반적으로 회사가 수집하여 전자적 파일형태로 관리하는 개인정보는 목적 달성 시점에 바로 삭제 됩니다.

        나. 파기방법
        종이에 출력된 개인정보는 분쇄기로 분쇄 또는 소각하거나 화학약품 처리를 하여 용해하여 파기하고, 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>10. 회원 및 법정대리인의 권리와 그 행사방법</p>
    <p className={previousPolicyBodyClass}>
      {`회원 및 법정대리인은 언제든지 등록되어 있는 자신 또는 당해 만14세미만 아동의 개인정보를 회사의 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하여 열람/수정/탈퇴를 요청할 수 있습니다. 회원 또는 법정대리인이 개인정보의 오류에 대한 정정을 요청한 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 회사는 회원 또는 법정대리의 요청에 의해 해지 또는 삭제된 개인정보는 브이드림(www.vdream.co.kr)이 수집하는 개인정보의 보유 및 이용기간에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>11. 개인정보 취급 업무의 위탁</p>
    <p className={previousPolicyBodyClass}>
      {`회사는 서비스 향상을 위해서 고객님의 개인정보가 필요한 경우 동의 등 법률상의 요건을 구비하여 외부에 수집•취급•관리 등을 위탁하여 처리할 수 있으며, 제 3자에게 제공할 수 있습니다. 회사는 개인정보의 처리와 관련하여 아래와 같이 업무를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다. 또한 공유하는 정보는 당해 목적을 달성하기 위하여 필요한 최소한의 정보에 국한됩니다. 회사는 고객님의 개인정보를 당사가 제공하는 인터넷 서비스 외의 용도로 사용하거나 고객님의 동의 없이 제3자에게 제공하지 않습니다. 필요에 의하여 제3자에게 제공할 경우에는 고객님에게 알리고 별도의 동의를 받습니다. 다만, 다음 각 호의 경우에는 예외로 합니다.
        ㅤ1) 당사의 이용약관을 위배하거나 서비스를 이용하여 타인에게 피해를 주거나 미풍양속을 해치는 위법행위를
        ㅤㅤ 한 사람 등에게 법적인 조치를 취하기 위해 개인 정보를 공개해야 한다고 판단되는 경우
        ㅤ2) 법령의 규정에 의하거나, 수사상의 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구 있는 경우
        ㅤ3) 통계 작성, 학술연구, 시장 조사, 정보 제공 및 공지 안내 메일 발송의 경우로서 특정 개인을 식별할 수 없는
        ㅤㅤ 형태로 제공되는 경우`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>12. 개인정보보호를 위한 기술 및 관리적 대책</p>
    <p className={previousPolicyBodyClass}>
      {`회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.

        가. 관리적 조치
        인정보 취급 직원 교육 : 개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하고 담당자에 대한 수시 교육을 통하여 개인정보처리방침의 준수를 항상 강조하고 있습니다.

        나. 기술적 조치
        해킹 등에 대비 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신/점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>13. 개인정보 자도우집장치의 설치·운영 및 그 거부에 대한 사항</p>
    <p className={previousPolicyBodyClass}>
      {`가. 회사가 제공하는 인터넷서비스를 통하여 고객의 정보를 저장하고 수시로 찾아내는 쿠키를 설치·운용할 경우도 있습니다.
        쿠키란 웹 서버가 웹 브라우저에 보내어 저장했다가 서버의 부가적인 요청이 있을 때 다시 서버로 보내주는 문자열 정보를 말합니다. 고객이 웹사이트에 접속을 하면 고객의 브라우저에 있는 쿠키의 내용을 읽고, 추가정보를 찾아 접속에 따른 성명 등의 추가 입력 없이 서비스를 제공할 수 있습니다.

        나. 고객은 쿠키 설치에 대한 선택권을 가지고 있습니다.
        웹 브라우저 상단의 “도구 → 인터넷옵션 → 개인정보 → 고급” 에서 모든 쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를 거부할 수있습니다. 단, 고객이 쿠키 설치를 거부하였을 경우 서비스 이용에 불편이 있거나, 서비스 제공에 어려움이 있을 수 있습니다.

        다. 쿠키는 브라우저의 종료 시 만료됩니다.`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>14. 이용자의 권리와 의무</p>
    <p className={previousPolicyBodyClass}>
      {`가. 고객님의 개인정보를 최신의 상태로 정확하게 입력하여 불의의 사고를 예방해 주시기 바랍니다. 입력한 부정확한 정보로 인해 발생하는 사고의 책임은 고객님께 있으며 타인 정보의 도용 등 허위정보를 입력할 경우 회원자격이 상실될 수 있습니다.

        나. 고객님은 개인정보를 보호받을 권리와 함께 스스로를 보호하고 타인의 정보를 침해하지 않을 의무도 가지고 있습니다. 고객님의 개인정보가 유출되지 않도록 조심하시고 게시물을 포함한 타인의 개인정보를 훼손하지 않도록 유의해 주십시오. 만약 이 같은 책임을 다하지 못하고 타인의 정보를 훼손할 시에는「정보통신망이용촉진 및 정보보호 등에 관한 법률」 등에 의해 처벌받을 수 있습니다.`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>15. 서비스의 개인정보 보호책임자에 관한 사항</p>
    <p className={previousPolicyBodyClass}>
      {`이용자의 개인정보를 보호하고 개인정보와 관련된 불만 등을 처리하기 위하여 회사는 고객서비스담당 부서 및 개인정보관리책임자를 두고 있습니다. 이용자의 개인정보와 관련한 문의사항은 아래의 고객서비스담당 부서 또는 개인정보관리책임자에게 연락하여 주시기 바랍니다.

        개인정보관리 담당책임자
        ㅤ- 성명 : 유진섭
        ㅤ- 부서 : 전략사업팀
        ㅤ- E-mail : jsyoo@vdream.co.kr
        ㅤ- 전화번호 : 1644.8619

        기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
        ㅤ1. 개인분쟁 조정위원회 (www.1336.or.kr / 1336)
        ㅤ2. 정보보호마크인증 위원회 (www.eprivacy.or.kr / 02-580-0533~4)
        ㅤ3. 대검찰청 인터넷 범죄수사센터 (www.spo.go.kr/ 02-3480-3600)
        ㅤ4. 경찰청 사이버테러 대응센터 (www.ctrc.go.kr / 02-392-0330)`}
    </p>
    <br />
    <p className={previousPolicyTitleClass}>16. 개인정보취급방침의 개정과 그 공지</p>
    <p className={previousPolicyBodyClass}>
      {`현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.
        ㅤ- 공고일자 : 2020년 1월 1일
        ㅤ- 시행일자 : 2020년 1월 1일`}
    </p>
  </>,
];
